import { createTheme } from "@material-ui/core/styles";
//import purple from '@material-ui/core/colors/purple';
//import green from '@material-ui/core/colors/green';

const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: [
      '"Noto IKEA"',
      '"Noto IKEA Arabic"',
      "Roboto",
      '"Open Sans"',
      "sans-serif",
    ].join(","),
  },
  // palette: {
  //   primary: {
  //     main: purple[500],
  //   },
  //   secondary: {
  //     main: green[500],
  //   },
  // },
});

export default theme;
